// src/lib/errorHandler.ts
// Maps backend DOMAIN.CODE error codes to i18n-translated user-facing messages.
// Uses the i18n instance directly so it works outside React components
// (axios interceptors, queryClient callbacks).

// i18next v23+ with TypeScript 4.9.5 (CRA) causes TS2554 on .t() calls.
// Cast to any to match the pattern used in src/i18n/index.ts:25.
import i18nImport from '../i18n/index';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const i18n = i18nImport as any;

export function getErrorMessage(code: string | undefined | null): string {
    if (!code) return i18n.t('errors:GENERIC');
    return i18n.t(`errors:${code}`, { defaultValue: i18n.t('errors:GENERIC') });
}
